import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import GeneralLedgerAccountType from "@/models/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountType";
import GeneralLedgerAccountState from "@/models/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountState";

export default class GeneralLedgerAccount extends BaseInstitutionEntity {
    name: string;
    code: number;
    currency: string;
    type: GeneralLedgerAccountType;
    state: GeneralLedgerAccountState;
    createdAtUtc: Date;
    updatedAtUtc: Date;
}